import AbaTypeEnum from './AbaTypeEnum';
import IWarehouseLoanTransactionAba from './IWarehouseLoanTransactionAba';
import IWarehouseLoanTransactionAbaHistory from './IWarehouseLoanTransactionAbaHistory';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseWarehouseLoanTransactionAba(raw: any): IWarehouseLoanTransactionAba {
    return {
        abaType: raw.abaType as AbaTypeEnum,
        amountPrepaidInterestTotal: raw.amountPrepaidInterestTotal,
        createdTime: raw.createdTime,
        transactionCount: raw.transactionCount,
        uuid: raw.uuid,
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parsewarehouseLoanTransactionAbaHistory(raw: any): IWarehouseLoanTransactionAbaHistory {
    return {
        createdTime: raw.createdTime,
        description: raw.description,
        uuid: raw.uuid,
    };
}
